import ModalStack from '@/components/Custom/ModalStack';

export const unstable_settings = {
  anchor: 'edit/index',
};

export default function PrivateOrganizationOrganizationIdMemberPersonIdLayoutRoute() {
  return <ModalStack />;
}
